<template>
  <main v-loading="load.page">
    <section class="l">
      <figure>
        <search class="search" :noAnimation="true" @change="changeKeyword" />
        <!-- 筛选栏目 -->
        <nav>
          <el-select v-model="search.KindName" class="select" size="mini" :clearable="true" placeholder="签证类别">
            <el-option v-for="v in KindNames" :key="v" :label="v" :value="v">
            </el-option>
          </el-select>
          <el-select v-model="search.FormName" class="select" size="mini" :clearable="true" placeholder="签证形式">
            <el-option v-for="v in FormNames" :key="v" :label="v" :value="v">
            </el-option>
          </el-select>
        </nav>
      </figure>

      <!-- 左侧根据 签证类别 筛选后的产品列表 -->
      <ul v-loading="load.list">
        <li :class="{ listItemActive: activeProductId === item.id }" v-for="(item, index) in getVisaList"
          :key="item.VisaProductID" @click="changeProduct(item)">
          <h3>
            <span>{{ item.visa_type_label }}</span><b>{{ item.list_title }}</b>
          </h3>
          <p>
            <time>办理<b>{{ item.fastest_processing_days }}</b>个工作日起</time>
            <strong>
              <span class="price">{{ item.starting_price }}</span>
            </strong>
          </p>
        </li>
      </ul>
    </section>

    <section class="r" v-loading="load.detail">
      <header id="point0">
        <h2>{{ info.name }}</h2>
        <!-- 顶部标签模块 -->
        <div class="tag">
          <span v-for="v in info.serves" :key="v">{{ v }}</span>
        </div>
        <ul>
          <li v-for="(item, index) in timeList" :key="index">
            <span>{{ item.title }}</span><b>{{ item.val }}</b>
          </li>
          <!-- <li>
            <span>入境次数</span><b>{{ info.visa_entries }}</b>
          </li>
          <li>
            <span>停留天数</span><b>{{ info.visa_stay_days }}</b>
          </li>
          <li>
            <span>有效期</span><b>{{ info.visa_expiry_date }}</b>
          </li> -->
          <li>
            <span>是否面签</span><b>{{ info.visa_need_interview_label }}</b>
          </li>
          <li>
            <span>是否打指模</span><b>{{ info.visa_need_fingerprinting_label }}</b>
          </li>
        </ul>

        <!-- 属性选择模块 -->
        <!-- 2024-12-11 
         增加 
           1:办理时长(所需工作日) 的条件判断,只有当所需工作日的数组至少有两项时;
           2:属性列表长度大于等于1时 ;
         才显示 属性选择模块 
         -->

        <div class="attrGroup"
          v-if="customProcessingDateList && customProcessingDateList.length > 1 && sku_attributeList && sku_attributeList.length">
          <h3>属性选择</h3>

          <!-- 2024-11-04 新增自定义 办理时长(所需工作日) -->
          <template v-if="customProcessingDateList && customProcessingDateList.length">
            <figure class="attrItem">
              <h4>办理时长(所需工作日)--自定义</h4>
              <div class="skuChooseList">
                <figcaption class="sku_items" v-for="(item, index) in customProcessingDateList" :key="index"
                  :class="activedCustomProcessing == item ? 'activeItem' : ''"
                  @click="chooseCustomProcessingDate(item)">{{ item +
                    '工'
                  }}
                </figcaption>
              </div>
            </figure>
          </template>

          <figure class="attrItem" v-for="(item, i) in sku_attributeList" :key="i">
            <!-- 2024-11-04 属性选择 排除 id=73 办理时长(所需工作日)的显示 -->
            <template
              v-if="item.sku_attribute_values && item.sku_attribute_values.length && item.sku_attribute_values.length > 1 && item.id != 73">
              <h4>{{ item.title }}</h4>
              <div class="skuChooseList">
                <figcaption :class="isSelectedAttr(item2.id) ? 'activeItem' : ''" class="sku_items"
                  v-for="(item2, i2) in item.sku_attribute_values" :key="item2.id" @click="chooseSkuAttr(item2)">{{
                    item2.attribute_value }}
                </figcaption>
              </div>
            </template>
          </figure>

        </div>

        <div class="meal">
          <h3>套餐选择</h3>
          <nav v-if="info.visa_prices">

            <!-- 无选择属性时 -->
            <template v-if="!selectedSkukList.length && Number(activedCustomProcessing) < 0">
              <b :class="{ on: item.id === selectedSku_Id }" class="skuItemWrap" v-for="(item, i) in sku_List"
                :key="item.id" @click="selectedSku(item, i)">
                <span class="skuListTitle">{{ item.list_title }}</span>
                <template v-if="item.visa_workdays_label">
                  <p class="predictDate">预计{{ item.visa_workdays_label }}出签</p>
                  <p class="earliestDate">(预计最早{{ getEarlyTravelDate(item.visa_processing_days) }}出发)</p>
                </template>
                <p v-if="item.visa_reminder" class="skuReminder">({{ item.visa_reminder }})</p>
              </b>
            </template>

            <!-- 有选择属性时的套餐列表 -->
            <template v-else>
              <template v-if="filtrateVisaProductList && filtrateVisaProductList.length">
                <b :class="{ on: item.id === selectedSku_Id }" class="skuItemWrap"
                  v-for="(item, i) in filtrateVisaProductList" :key="item.id" @click="selectedSku(item, i)">
                  <span class="skuListTitle">{{ item.list_title }}</span>
                  <template v-if="item.visa_workdays_label">
                    <p class="predictDate">预计{{ item.visa_workdays_label }}出签</p>
                    <p class="earliestDate">(最早{{ getEarlyTravelDate(item.visa_processing_days) }}出发)</p>
                  </template>
                  <p v-if="item.visa_reminder" class="skuReminder">({{ item.visa_reminder }})</p>
                </b>
              </template>
              <template v-else>
                <b class="nothingChoose">暂无可选套餐</b>
              </template>
            </template>

          </nav>

          <h3>出行日期和份数</h3>
          <div class="label">
            <el-date-picker type="date" ref="day" v-model="sku_travel_date" value-format="yyyy-MM-dd"
              :picker-options="dayOptions" placeholder="选择日期" @change="changeDatePicker">
            </el-date-picker>
            <el-input-number v-model="sku_quantity" :min="1" label="份数"></el-input-number>
          </div>
        </div>

        <div class="price">
          <div class="paymentType" v-if="selectedSku_Info && selectedSku_Info.dealer_price">
            结算方式 :
            <el-radio-group v-model="selectedPaymentType" class="radioGroupWrap">
              <el-radio label="1" border>分销商价</el-radio>
              <el-radio label="2" border>零售价</el-radio>
            </el-radio-group>
          </div>
          <p>
            <b>{{ getPrice }}</b>
            <span>{{ info.SupplierName }}</span>
          </p>
          <div class="btn" v-if="showCreateOrderStatus">
            <button @click="placeAnOrder">立即办理</button>
          </div>
        </div>

      </header>

      <ul class="time_lines">
        <li :class="{ on: getPointIndex === 1 }" v-if="info.description && info.description.description"
          @click="goPoint(1)">
          <span>产品详情</span>
        </li>
        <li :class="{ on: getPointIndex === 2 }" @click="goPoint(2)">
          <span>所需资料</span>
        </li>
        <li :class="{ on: getPointIndex === 3 }" @click="goPoint(3)">
          <span>注意事项</span>
        </li>
        <li :class="{ on: getPointIndex === 4 }" @click="goPoint(4)">
          <span>样板展示</span>
        </li>
      </ul>

      <section id="point1" v-if="info.description && info.description.description">
        <h3><span>产品详情</span></h3>
        <div class="nodes" v-html="info.description.description || '--'"></div>
      </section>

      <section id="point2">
        <h3 class="noBorder">
          <span>所需资料</span>
        </h3>
        <nav class="subTitle">
          <span :class="{ on: info.materialIndex === i }" v-for="(v, i) in info.filesByTraveler" :key="i"
            @click="changeMaterialIndex(i, v.length)">{{ v.text }}({{ v.files.length }})</span>
        </nav>
        <ul class="data" v-loading="changinformation">

          <li v-for="v in info.filesByTraveler_detail" :key="v.VisaFileID">
            <h5>{{ v.Name }}</h5>
            <p v-html="v.body"></p>
            <a :style="{
              right: v.file_url && v.file_url !== 'NULL' ? '200px' : '',
            }" v-show="v.img_url && v.img_url !== 'NULL'" :href="v.img_url" :download="v.Name" target="_blank">浏览资料</a>

            <a v-show="v.file_url && v.file_url !== 'NULL'" :href="v.file_url" :download="v.Name"
              target="_blank">下载资料</a>
          </li>
        </ul>
      </section>

      <section id="point3" v-if="productInfo && productInfo.spu && productInfo.spu.spu_knowledge_content">
        <h3><span>注意事项</span></h3>
        <div class="nodes" v-html="encodeHTML(productInfo.spu.spu_knowledge_content)"></div>
      </section>

      <section id="point4" v-show="info.visa_models">
        <h3><span>样板展示</span></h3>
        <div class="nodes">
          <template v-if="info.visa_models && info.visa_models.length">
            <img v-for="v in info.visa_models" :key="v.VisaModelID" :src="v.img_url" alt="" />
          </template>
          <template v-else>暂无样板</template>
        </div>
      </section>

    </section>

    <ul class="time_line" :class="{ hide: getPointIndex === 1 }">
      <!-- <li :class="{ on: getPointIndex === 0 }" @click="goPoint(0)"><span>产品信息</span></li> -->
      <li :class="{ on: getPointIndex === 1 }" @click="goPoint(1)"
        v-if="info.description && info.description.description">
        <span>产品详情</span>
      </li>
      <li :class="{ on: getPointIndex === 2 }" @click="goPoint(2)">
        <span>所需资料</span>
      </li>
      <li :class="{ on: getPointIndex === 3 }" @click="goPoint(3)">
        <span>注意事项</span>
      </li>
      <li :class="{ on: getPointIndex === 4 }" @click="goPoint(4)">
        <span>样板展示</span>
      </li>
      <li class="noBefore" v-if="showCreateOrderStatus">
        <el-button type="danger" @click="goPoint(0)">立即办理</el-button>
      </li>
    </ul>

  </main>
</template>

<script>
import search from "@components/search";
import $visa from "@api/visa";
import $user from "@api/user";

// import $tool from "@api/tool";
import moment from "moment";
import { mapState } from "vuex";
import tool from '@assets/js/tool';
import day from '@assets/js/day';
// import { 价格 } from "pinyin/data/phrases-dict";

export default {
  components: {
    search,
  },

  data() {
    return {
      productInfo: {}, //产品相关信息 2024-10-09
      timeList: [],//顶部日期相关参数 2024-10-09
      value1: '',
      activeProductId: '',//左侧栏目 当前选中的产品ID
      selectedSku_Info: null, // //选中的SKU的相关信息
      selectedSku_Id: '',//选中的SKU的ID
      showCreateOrderStatus: true,//立即办理按钮展示状态
      sku_List: [],//套餐列表
      sku_travel_date: null,//计划出行日期
      sku_quantity: 1,//购买数量 默认:1
      info: {
        material: [],
        materialIndex: 0,
        meal: null, // 套餐
        day: null, // 出行日期
        count: 1, // 数量
      }, // 详情
      list: [], // 列表
      // 加载
      load: {
        list: false,
        detail: false,
        page: true,
      },
      FormNames: [], // 签证形式
      KindNames: [], // 签证类别
      search: {
        FormName: null,
        KindName: null,
        infoIndex: 0,
        productID: '',//选择的产品ID
      },
      dayOptions: {
        // 出行日期限制，非周末，叠加工作日
        disabledDate: (date) => {
          if (!this.selectedSku_Id) return null;
          const activeSkuItem = this.sku_List.find((item) => { return item.id == this.selectedSku_Id });
          const addDay = ~~activeSkuItem.visa_processing_days; // 需要添加的工作日
          const targetStartDate = tool.getDateAfterWorkingDays(moment().format('YYYY-MM-DD'), Number(addDay));
          return Date.parse(targetStartDate) > Date.parse(date);
        },
      },
      scrollTop: 0,
      scrollVal: [],
      isClick: true,
      sku_attributeList: [],//属性列表
      selectedSkukList: [],//已选属性
      countryHolidayList: [],//当前国家的假日列表 [] 可能为空
      selectedPaymentType: '1',//结算方式 默认 登录后为：分销商价格
      changinformation: false,//选择 办签人身份时的 加载中状态 默认false
      customProcessingDateList: [],//自定义 办理时长(所需工作日) 数组 默认为[],内部数据 将由 sku的所有所需工作日的合集（已除重）
      activedCustomProcessing: -1,//已选择的 办理时长(所需工作日) 
    };
  },
  watch: {
    selectedSku_Id: {
      handler(newVal, oldval) {
        let _this = this;
        if (newVal) {
          const activeSkuItem = _this.sku_List.find((item) => { return item.id == newVal });
          if (activeSkuItem && Object.keys(activeSkuItem).length) {
            _this.selectedSku_Info = activeSkuItem;

          }
        }
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    ...mapState(["userInfo"]),
    // distribution:分销商; [分销商价]
    // staff:员工;[分销商价]
    // partner:合作伙伴;[分销商价]
    // vip:直客；[直客价]
    // EVIP:大客户[直客价]

    // 计算总价
    getPrice() {
      let _this = this;
      if (!this.selectedSku_Id) return 0;
      let addUpPrice = 0;

      const activeSkuItem = this.sku_List.find((item) => { return item.id == this.selectedSku_Id });
      if (activeSkuItem && Object.keys(activeSkuItem).length) {
        // const unitPrices = activeSkuItem.dealer_price ? Number(activeSkuItem.dealer_price) : Number(activeSkuItem.retail_price);
        let unitPrices = 0;
        const hasDealerPriceList = ['distribution', 'staff', 'partner'];
        if (_this.userInfo && _this.userInfo.identify && hasDealerPriceList.includes(_this.userInfo.identify)) {
          // 2024-10-09   将单价修改为 通过结算方式选择后的价格
          unitPrices = _this.selectedPaymentType == "1" ? Number(activeSkuItem.dealer_price) : Number(activeSkuItem.retail_price);
        } else {
          unitPrices = Number(activeSkuItem.retail_price) || 0;
        }
        addUpPrice = Number(unitPrices * _this.sku_quantity).toFixed(2)
      } else {
        addUpPrice = 0;
      }
      return addUpPrice || 0;
    },

    getVisaList() {
      const { list } = this;
      const { FormName, KindName } = this.search;

      let filterList = JSON.parse(JSON.stringify(list));

      // filterList.map((item) => {
      //   item.starting_price = item.starting_price ? this.setNormalPrice(item.starting_price) : 0;
      //   item.starting_dealer_price = item.starting_dealer_price ? this.setNormalPrice(item.starting_dealer_price) : 0;
      // })

      // 判断用户身份后显示分销商/直客 价格
      filterList.map((item) => {
        // item.starting_price = item.starting_dealer_price ? this.setNormalPrice(item.starting_dealer_price) : this.setNormalPrice(item.starting_price);

        // 2024-11-13 使用新字段 first_dealer_price ||  first_price
        item.starting_price = item.first_dealer_price ? this.setNormalPrice(item.first_dealer_price) : this.setNormalPrice(item.first_price);
      })


      return filterList.filter((v) => {
        if (Boolean(FormName) !== false && v.visa_form_label !== FormName) {
          return false;
        }
        if (Boolean(KindName) !== false && v.visa_type_label !== KindName) {
          return false;
        }
        return true;
      });
    },
    getPointIndex() {
      const list = this.scrollVal;
      const i = list.findIndex((v) => this.scrollTop < v) - 1;
      return i < 0 ? (this.scrollTop > 100 ? list.length - 1 : 0) : i;
    },
    // 获取筛选条件判断之后的产品列表
    filtrateVisaProductList() {
      let _this = this;
      let filterList = [];//筛选过后的套餐数组
      let productList = JSON.parse(JSON.stringify(_this.info.visa_prices)); //所有套餐数组;
      let selectedAttrbuiteIdList = []; //已选属性值的ID合集;
      _this.selectedSkukList.map((item) => { selectedAttrbuiteIdList.push(item.id) });

      if (selectedAttrbuiteIdList.length) {
        if (selectedAttrbuiteIdList.length == 1) {
          productList.map((item) => {
            if (item.attribute_value_ids.includes(selectedAttrbuiteIdList[0])) {
              filterList.push(item);
            }
          })
        } else {
          productList.map((item) => {
            if (_this.getSameAtttrLength(item.attribute_value_ids, selectedAttrbuiteIdList) >= selectedAttrbuiteIdList.length) {
              filterList.push(item);
            }
          })
        }
      }


      // 当 有勾选 办理时长时 
      if (Number(_this.activedCustomProcessing) >= 0) {
        // 当 有筛选属性时,需要通过filterList数组中筛选数据
        if (selectedAttrbuiteIdList.length) {
          let data = filterList.filter((item) => item.visa_processing_days == _this.activedCustomProcessing);
          filterList = data || [];
        } else {
          // 否则 直接通过productList数组筛选
          let data = productList.filter((item) => item.visa_processing_days == _this.activedCustomProcessing);
          filterList = data || [];
        }
      }

      _this.selectedSku_Id = filterList.length ? filterList[0]['id'] : '';

      return filterList;
    },
  },
  filters: {
    getMaterialName(i) {
      const arr = ["在职人员", "退休", "自由职业", "学生", "学龄前儿童"];
      return arr[i];
    },

  },
  async created() {
    let _this = this;
    // 检测登录状态,更新用户token,用以获取最新的产品信息(包含分销商价格)
    await $user.checkLogin().then(async (res) => {
      if ("success" in res) {
        _this.updateUserInfo(res);
      } else {
        // 2024-10-09 当用户token过期时,静默登录
        if (_this.userInfo != null) {
          const localUserSecret = localStorage.getItem('privacyInfo')
          let secretInfo = localUserSecret ? JSON.parse(localUserSecret) : ''; //序列化用户登录存储的账号与密码 || ''
          if (!secretInfo) return;

          await $user.login(secretInfo).then(async (res) => {
            const { error } = res;
            if (error) {
              return;
            }
            await _this.updateUserInfo(res);
          });
        }
      }
    })


    const { id, detailId, pdid, spu_id } = this.$route.query;
    if (spu_id) {
      _this.activeProductId = Number(spu_id);
    }
    // const orginalParam = _this.$route.query;
    // if (orginalParam.spu_id) {
    //   _this.$router.push({ path: "./visa_list", query: { ...orginalParam, spu_id: orginalParam.spu_id } });
    // } else {
    //   _this.$router.push({ path: "./visa_list", query: { ...orginalParam, spu_id: _this.activeProductId } });
    // }
    this.getList(id, detailId, pdid);

    window.addEventListener("scroll", this.scrollFun, true);

    // // 消息提示 11-03号之前才显示 提示
    // if (day(new Date).format('YYYY-MM-DD') < '2023-11-04') {
    //   this.$notify({
    //     title: '网站平台升级更新通知！',
    //     dangerouslyUseHTMLString: true,
    //     position: 'bottom-right',
    //     duration: 5000,
    //     message: `
    //     <div className="hint">
    //       <b>因网站平台能力更新升级，有部分变更，特此通知如下：</b>
    //       <p>1. 目前 签证产品下单后的订单页面为： <a  href="./orderCenter">订单中心</a></p>
    //       <p>2. 即日起将接入新版签证产品下单流程,下单后销售结算界面为： <a target="_blank" href="https://oa.cstravel.cn/oa/xorder/order/index">Sass订单管理</a></p>
    //     </div>
    //   `
    //   })
    // }

  },
  methods: {
    // 选择指定的出行日期
    chooseCustomProcessingDate(item) {
      if (this.activedCustomProcessing == item) {
        this.activedCustomProcessing = -1
      } else {
        this.activedCustomProcessing = item;
      }
    },
    encodeHTML(str) {
      var arrEntities = {
        'lt': '<',
        'gt': '>',
        'nbsp': ' ',
        'amp': '&',
        'quot': '"'
      };
      return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) {
        return arrEntities[t];
      });
    },
    // 在sku_attribute_value 中查找指定属性下的 指定值的 内容 2024-10-09
    getAttrValueById(data, id) {
      let _this = this;
      const attrObj = data.find((item) => item.attribute_id == id) || {};
      let finalValue = '';

      if (Object.values(attrObj).length) {
        const attrId = attrObj.attribute_value_id || '';
        const targets = _this.sku_attribute_value.find((item) => item.id == id);
        if (attrId) {
          const finalObj = targets.sku_attribute_values.find((item) => item.id == attrId) || {};
          if (Object.keys(finalObj).length) {
            finalValue = finalObj.attribute_value
          }
        }

      }
      return finalValue;
    },

    // 选择sku后,获取顶部展示的内容 2024-10-09
    getTopInfoBySelectedSku(data) {
      let _this = this;
      const attrList = data.attrs;

      const validityInfo = _this.getAttrValueById(attrList, 112) || _this.productInfo.spu.visa_expiry_date;
      const durationInfo = _this.getAttrValueById(attrList, 111) || this.productInfo.spu.visa_stay_days;
      const entriesTimesInfo = _this.getAttrValueById(attrList, 110) || this.productInfo.spu.visa_entries;

      _this.timeList = [{
        title: '有效期限',
        val: validityInfo
      },
      {
        title: '最长停留',
        val: durationInfo
      },
      {
        title: '入境次数',
        val: entriesTimesInfo
      }
      ];

    },
    // 获取最早可出行日期
    getEarlyTravelDate(day) {
      let _this = this;
      const daysx = tool.getDateAfterWorkingDaysWithHolidays(day, _this.countryHolidayList);
      return daysx;
    },
    // 切换日期时间
    changeDatePicker(e) {
      let _this = this;
      const activeSkuItem = this.sku_List.find((item) => { return item.id == this.selectedSku_Id });
      const addDay = ~~activeSkuItem.visa_processing_days; // 需要添加的工作日
      const targetStartDate = tool.getDateAfterWorkingDays(moment().format('YYYY-MM-DD'), Number(addDay));
      if (e < targetStartDate) {
        _this.sku_travel_date = null;
      } else {
        _this.sku_travel_date = e;
      }
    },
    // 选择套餐
    selectedSku(item, index) {
      let _this = this;
      _this.selectedSku_Id = item.id;
      _this.sku_travel_date = null;//清空日期
      _this.sku_quantity = 1;//清空选购数量
      _this.getTopInfoBySelectedSku(item);
    },
    // 获取筛选条件判断之后的产品列表
    getAfterFilterList() {
      let _this = this;
      if (!_this.info && !_this.info.visa_prices) return [];
      let filterList = [];//筛选过后的套餐数组
      let productList = _this.info.visa_prices || []; //所有套餐数组;
      if (!productList.length) return [];
      let selectedAttrbuiteIdList = []; //已选属性值的ID合集;

      _this.selectedSkukList.map((item) => { selectedAttrbuiteIdList.push(item.id) });

      if (selectedAttrbuiteIdList.length) {
        if (selectedAttrbuiteIdList.length == 1) {
          productList.map((item) => {
            if (item.attribute_value_ids.includes(selectedAttrbuiteIdList[0])) {
              filterList.push(item);
            }
          })
        } else {
          productList.map((item) => {
            if (_this.getSameAtttrLength(item.attribute_value_ids, selectedAttrbuiteIdList) >= selectedAttrbuiteIdList.length) {
              filterList.push(item);
            }
          })
        }
      }

      if (!filterList.length) {
        _this.showCreateOrderStatus = false;
      } else {
        _this.showCreateOrderStatus = true;
      }
      return filterList;
    },
    // 获取 两组数组的相同数组项 的数量
    getSameAtttrLength(arr1, arr2) {
      let sameNum = 0;
      arr1.map(item => {
        if (arr2.includes(item)) {
          sameNum += 1;
        }
      });
      return sameNum;
    },
    // 传入属性ID,判断已选属性种是否包含此ID
    isSelectedAttr(attrId) {
      let status = false;
      const checkStatus = this.selectedSkukList.find((item) => {
        return item.id == attrId;
      })
      if (checkStatus && Object.keys(checkStatus).length) status = true;
      return status;
    },
    // 选择属性事件 
    chooseSkuAttr(param) {
      let _this = this;
      const { id, attribute_id } = param;
      _this.sku_travel_date = null;//清空日期
      _this.sku_quantity = 1;//清空选购数量

      // 判断是否包含了勾选的 属性模块；
      let isIncludesItem = _this.selectedSkukList.find((item) => {
        return item.attribute_id == attribute_id;
      });

      if (!isIncludesItem) {
        _this.selectedSkukList.push(param)
      } else {
        _this.selectedSkukList.map((item, index) => {
          // 反选
          if (item.attribute_id == attribute_id && item.id == id) {
            _this.selectedSkukList.splice(index, 1);
          } else if (item.attribute_id == attribute_id) {
            // 勾选
            _this.selectedSkukList.splice(index, 1, param)
          }
        })
      }

    },
    // 返回正常显示的价格
    setNormalPrice(price) {
      return tool.ConversionPrice(price)
    },
    // 下单
    placeAnOrder() {
      // const { day, count, meal, visa_ins, visa_prices } = this.info;
      let _this = this;
      if (!_this.sku_travel_date) {
        this.$message.warning("请选择出行日期！");
        this.$refs.day.focus();
        return;
      }
      if (!_this.sku_quantity) {
        this.$message.warning("请选择购买数量！");
        return
      }

      if (!_this.selectedSku_Id) {
        this.$message.warning("请选择套餐！");
        return
      }

      const orderInfo = this.sku_List.find((item) => { return item.id == this.selectedSku_Id });
      const pageParams = {
        order: orderInfo,
        day: _this.sku_travel_date,
        count: _this.sku_quantity,
        info: _this.info
      }
      // orderInfo:sku数据
      // visa_ins:保险费用
      // day:出行日期
      // count:数量
      this.$router.push({
        name: "order_add",
        params: pageParams
      });
      // return;
      // this.$router.push({
      //   name: "order_add",
      //   params: {
      //     info: this.info,
      //     order: orderInfo,
      //     ins: visa_ins,
      //     day,
      //     count,
      //   },
      // });
    },
    // 获取左侧产品列表
    async getList(id, detailId, pdid) {
      this.toggleLoad("list");
      let _this = this;

      // 通过国家ID获取当前国家的节假日列表
      await $visa.getHolidayByCountryId(id).then((res) => {
        _this.countryHolidayList = Object.keys(res).length ? res.data : [];
      })

      await $visa.getVisaProductList(id).then((res) => {

        // _this.activeProductId = res.data.products[0]['id']; //设置默认生效的产品ID;

        // 加载左侧产品列表时,设置首个spu_id -------St
        const orginalParam = _this.$route.query;
        if (orginalParam.spu_id) {
          _this.activeProductId = Number(orginalParam.spu_id); //设置默认生效的产品ID;
          _this.$router.push({ path: "./visa_list", query: { ...orginalParam, spu_id: orginalParam.spu_id } });
        } else {
          _this.activeProductId = res.data.products[0]['id']; //设置默认生效的产品ID;
          _this.$router.push({ path: "./visa_list", query: { ...orginalParam, spu_id: _this.activeProductId } });
        }
        // 加载左侧产品列表时,设置首个spu_id -------Ed

        // 签证类别下拉框数据
        const visa_type_option = res.data.products.reduce((item, v) => {
          !item.includes(v.visa_type_label) && item.push(v.visa_type_label);
          return item;
        }, []);

        // 签证形式下拉框数据
        const visa_form_option = res.data.products.reduce((item, v) => {
          !item.includes(v.visa_form_label) && item.push(v.visa_form_label);
          return item;
        }, []);

        // 设置指定详情
        if (pdid) {
          const infoIndex = res.data.products.findIndex(
            (v) => v.id === Number(pdid)
          );
          this.search = { ...this.search, infoIndex };
        }

        this.list = res.data.products;
        this.KindNames = visa_type_option;
        this.FormNames = visa_form_option;
        this.clearSearch();
        this.getDetail();
        this.toggleLoad("list");
        this.load.page && (this.load = { ...this.load, page: false });
      });

    },
    // 获取 sku内的办理所需工作日数据
    getCustomProcessingData(data) {
      let visa_processing_daysList = data.map((item) => {
        return item.visa_processing_days;
      });
      visa_processing_daysList = [...new Set(visa_processing_daysList)].sort((a, b) => a - b);
      this.customProcessingDateList = visa_processing_daysList;
    },
    // 获取产品详情
    async getDetail() {
      this.toggleLoad("detail");
      const id = this.activeProductId ? this.activeProductId : this.list[0].id;
      let _this = this;
      await $visa.getVisaProductDetail(id).then((res) => {
        _this.productInfo = res.data;
        _this.sku_attribute_value = res.data.sku_attribute_value;

        // 获取 sku内的办理所需工作日数据
        _this.getCustomProcessingData(res.data.skus)



        _this.getTopInfoBySelectedSku(res.data.skus[0]); //设置顶部 有效期限等内容 2024-10-09
        let info = res.data.spu;
        info.starting_price = this.setNormalPrice(info.starting_price);
        let skus = res.data.skus || [];
        if (!skus.length) {
          this.toggleLoad("detail");
          _this.sku_List = [];
          this.sku_attributeList = [];
          return;
        }
        skus.map((item) => {
          item.retail_price = item.retail_price ? this.setNormalPrice(item.retail_price) : 0;
          item.dealer_price = item.dealer_price ? this.setNormalPrice(item.dealer_price) : 0;
        })
        _this.sku_List = skus;

        info.visa_prices = skus;
        _this.selectedSku_Id = skus[0]['id'];//设置默认生效的套餐ID
        this.sku_attributeList = res.data.sku_attribute_value;

        info.filesByTraveler_detail = info.filesByTraveler && info.filesByTraveler[0] ? info.filesByTraveler[0].files : {};
        // 服务承诺
        if (info.Promise == null || info.Promise == "") {

        } else {
          info.serves = info.Promise.split(",").filter((v) => !!v);
        }
        let material = [];
        info.filesByTraveler.map((item) => {
          material.push(item.files)
        })
        info.material = material;
        info.materialIndex = 0;


        this.info = info;
        this.setTitle(info.name);
        this.scrollTo();
        setTimeout(this.getPointY, 300);
        this.toggleLoad("detail");
      })

    },
    toggleLoad(attr) {
      this.load = { ...this.load, [attr]: !this.load[attr] };
    },
    clearSearch() {
      this.search = { ...this.search, KindName: null, FormName: null };
    },
    changeKeyword({ id }) {
      this.getList(id);
    },
    changeSearch(attr, value) {
      this.search = { ...this.search, [attr]: value };
    },
    // 点击切换 所需资料
    changeMaterialIndex(i, len) {
      if (len === 0) {
        return;
      }
      this.changinformation = true;
      setTimeout(() => {
        this.info = { ...this.info, materialIndex: i };
        this.info.filesByTraveler_detail = this.info.filesByTraveler[i].files;
        this.changinformation = false;
      }, 300);

    },
    scrollFun() {
      const top = document.documentElement.scrollTop;
      this.scrollTop = top;
    },
    goPoint(i) {
      const top = document.querySelector(`#point${i}`).offsetTop;
      this.scrollTo(top - 60);
    },
    getPointY() {
      const arr = [...new Array(5)].map((v, i) => {
        const obj = document.querySelector(`#point${i}`);
        return obj ? obj.offsetTop : 0;
      });
      this.scrollVal = arr;
    },
    // 产品栏 内选择产品事件
    changeProduct(detailInfo) {
      var _this = this;
      const currentProductId = detailInfo.id;// 选择项的产品ID；

      const orginalParam = _this.$route.query;
      _this.$router.push({ path: "./visa_list", query: { ...orginalParam, spu_id: currentProductId } });


      if (_this.activeProductId != currentProductId) {
        _this.activeProductId = currentProductId;
        _this.getDetail();
      }
      _this.selectedSkukList = []; //重置选择属性
      _this.sku_quantity = 1;//清空选购数量
      _this.sku_travel_date = null;//清空日期
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollFun);
  },
};
</script>

<style scoped src="./list2.css"></style>
<style scope>
.nodes strong {
  font-weight: bold;
}
</style>